import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["what_extra_json"];
const replaceJson = (json, keys, replace) => JSON.stringify(JSON.parse(json), (key, value) => keys.includes(key) ? replace : value);
export const scrubEvents = (events, keys, replace) => events.map(_ref => {
  let {
      what_extra_json
    } = _ref,
    event = _objectWithoutPropertiesLoose(_ref, _excluded);
  return Object.assign({
    what_extra_json: replaceJson(what_extra_json, keys, replace)
  }, event);
});